<template>
  <model @clickHandler="exit" class="tick-model">
    <img src="@img/fail.png" class="fail btn" @click="exit" />
  </model>
</template>

<script>
export default {
  name: 'tick-fail',
  data() {
    return {
      once: true,
    };
  },
  methods: {
    exit() {
      if (this.once) {
        this.$router.go(-1);
        this.once = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fail {
  position: absolute;
  @include center(453);
  @include w(453);
  top: 16vh;
  z-index: 11;
}
</style>
